import React, { lazy, useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import WebHomeProvider from "../Provider/WebHomeProvider";
import { Spin } from "antd";
const Header = lazy(() => import("../Component/Website/Header/Header"));
const Footer = lazy(() => import("../Component/Website/Footer/Footer"));
const WebLayout = () => {
  const {
    productMenuList,
    fetchProductMenuList,
    seoMetaListLoader,
    seoMetaFetch,
  } = useContext(WebHomeProvider);
  useEffect(() => {
    seoMetaFetch();
    fetchProductMenuList();
  }, []);
  // if (seoMetaListLoader) {
  //   return (
  //     <div className="splish_screen">
  //       <Spin />
  //     </div>
  //   );
  // }
  return (
    <>
      <Header productMenuList={productMenuList} />
      <Outlet />
      <Footer />
    </>
  );
};

export default WebLayout;
